
































import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { useWarmups } from '@/bundles/WarmUp/composables/useWarmups';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { defineComponent, ref, watch } from '@vue/composition-api';
import WarmUpListTable from '@/bundles/WarmUp/components/WarmUpListTable.vue';

export default defineComponent({
  name: 'WarmUps',

  components: {
    WarmUpListTable,
  },

  setup: function () {
    const { fetch, warmUps, total, pending } = useWarmups();
    const { tableOptions, pageOffset } = usePagination();
    const activeFilter = ref<boolean|null>(true);
    const activeItems = [
      { text: 'Active', value: true },
      { text: 'Inactive', value: false },
      { text: 'All', value: null },
    ];

    async function fetchWrapper() {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      const params: any[] = [
        {
          name: 'skip',
          value: pageOffset.value,
        },
        {
          name: 'take',
          value: tableOptions.value.itemsPerPage,
        },
        {
          name: 'type',
          value: 0,
        }
      ]

      if (activeFilter.value !== null) {
        params.push({
          name: 'active',
          value: activeFilter.value,
        });
      }

      await fetch(params);
    }
    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });
    watch(() => activeFilter, () => {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
      } else {
        fetchWrapper();
      }
    }, { deep: true });
    function optionsChangeEventHandler(options: ITableOptions) {
      tableOptions.value = { ...options };
    }

    return {
      warmUps,
      tableOptions,
      total,
      pending,
      activeFilter,
      activeItems,
      optionsChangeEventHandler,
      fetchWrapper,
    };
  },
});
